import { render, staticRenderFns } from "./CodesBudget.vue?vue&type=template&id=c3756092&scoped=true"
import script from "./CodesBudget.vue?vue&type=script&lang=ts"
export * from "./CodesBudget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3756092",
  null
  
)

export default component.exports